'use client';
import * as All from '@/element/common/elmntbase';
import { useRouter, useSearchParams } from 'next/navigation';

export default function Pginate({ pagination, ...props }: any) {
    const router = useRouter();
    const searchParams = useSearchParams();
    const loadPaginated = (i: any) => {
        const _params = new URLSearchParams(searchParams.toString());
        _params.set("page", i);
        router.push('?' + _params);
    }

    return (
        <>
            {pagination?.pagination?.allPageNumbers?.length > 1 ?
                <div className="pagination-wrapper mt-3 my-5">
                    <All.Pagination className='justify-content-center'>

                    </All.Pagination>
                </div>
                : null
            }
        </>
    )
}